import { Sidebar as UILabSidebar, SidebarProps } from '@superdispatch/ui-lab';
import { forwardRef } from 'react';
import {
  NAVIGATION_CONTENT_BANNER_HEIGHT_CSS_VAR,
  NAVIGATION_HEADER_BANNER_HEIGHT_CSS_VAR,
  viewportHeight,
} from 'shared/layout/NavigationHeaderBannerHeight';
import styled from 'styled-components';

const Wrapper = styled.div`
  display: contents;

  && > * {
    top: calc(
      var(${NAVIGATION_HEADER_BANNER_HEIGHT_CSS_VAR}, 0px) +
        var(${NAVIGATION_CONTENT_BANNER_HEIGHT_CSS_VAR}, 0px)
    );
    height: ${viewportHeight()};
  }
`;

export const Sidebar = forwardRef<HTMLDivElement, SidebarProps>(
  (props, ref) => (
    <Wrapper>
      <UILabSidebar ref={ref} {...props} />
    </Wrapper>
  ),
);

Sidebar.displayName = 'Sidebar';
